import React from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Button,
} from '@lockerpm/design';

import {
  KeyOutlined,
} from "@ant-design/icons";

import common from "../../../../../utils/common";
import global from "../../../../../config/global";

const ChangeAccountPassword = (props) => {
  const {
    className = '',
  } = props;
  const { t } = useTranslation();

  const isMobile = useSelector(state => state.system.isMobile);

  return (
    <div className={className}>
      <div className="flex justify-between">
        <p className="font-semibold text-xl">
          {t('security.change_password.title')}
        </p>
        <Button
          type='primary'
          ghost
          icon={<KeyOutlined />}
          onClick={() => common.openNewTab(`${global.urls.LOCKER_ID_URL}/security/password`)}
        >
          {isMobile ? '' : t('security.change_password.button')}
        </Button>
      </div>
      <p className="mt-1">
        {t('security.change_password.description')}
      </p>
    </div>
  );
}

export default ChangeAccountPassword;
